<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/9ZAryf/tc-custom/9780820348605.jpg?1699140296430" alt="This image is the cover for the book Alone atop the Hill"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Alone atop the Hill
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The memoir of “the first African American female reporter to gain entry into the closed society of the White House and congressional news correspondents” (Hank Klibanoff, coauthor of the Pulitzer Prize-winning <i>The Race Beat</i>).</b><br/>  <br/> In 1942 Alice Allison Dunnigan, a sharecropper’s daughter from Kentucky, made her way to the nation’s capital and a career in journalism that eventually led her to the White House. With <i>Alone Atop the Hill</i>, Carol McCabe Booker has condensed Dunnigan’s 1974 self-published autobiography to appeal to a general audience and has added scholarly annotations that provide historical context. Dunnigan’s dynamic story reveals her importance to the fields of journalism, women’s history, and the civil rights movement and creates a compelling portrait of a groundbreaking American.<br/>  <br/> Dunnigan recounts her formative years in rural Kentucky as she struggled for a living, telling bluntly and simply what life was like in a Border State in the first half of the twentieth century. Later she takes readers to Washington, D.C., where we see her rise from a typist during World War II to a reporter. Ultimately she would become the first black female reporter accredited to the White House; authorized to travel with a U.S. president; credentialed by the House and Senate Press Galleries; accredited to the Department of State and the Supreme Court; voted into the White House Newswomen’s Association and the Women’s National Press Club; and recognized as a Washington sports reporter.<br/>  <br/> In <i>Alone Atop the Hill</i>, “Dunnigan’s indelible self-portrait affirms that while the media landscape has changed, along with some social attitudes and practices, discrimination is far from vanquished, and we still need dedicated and brave journalists to serve as clarion investigators, witnesses, and voices of conscience (<i>Booklist</i>, starred review).</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alice Dunnigan, Carol McCabe Booker, Simeon Booker
      </h2>
      
      <p class="authorDescription body article">CAROL McCABE BOOKER is a former journalist and Washington, D.C., attorney. She is coauthor with her husband, journalist Simeon Booker, of the highly acclaimed history Shocking the Conscience: A Reporter’s Account of the Civil Rights Movement.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Georgia Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a8d2906c